export const FINANCIAL_PUBLICATION_STATES = Object.freeze([
    'DRAFT',
    'VALIDATED',
    'PUBLISHED',
    'SUPERSEDED',
    'WITHDRAWN',
]);
export const FINANCIAL_RESTATEMENT_STATES = Object.freeze([
    'ORIGINAL',
    'RESTATED',
    'SUPERSEDED',
]);
export function validateAuthoritativeFinancialResultMetadata(metadata) {
    const errors = [];
    if (!metadata.asOfTimestamp.trim())
        errors.push('asOfTimestamp is required');
    if (!metadata.generatedAt.trim())
        errors.push('generatedAt is required');
    if (!metadata.generatorVersion.trim())
        errors.push('generatorVersion is required');
    if (metadata.partialData && metadata.dataQuality.freshness !== 'PARTIAL') {
        errors.push('partialData requires PARTIAL freshness');
    }
    if (!metadata.partialData && metadata.dataQuality.freshness === 'PARTIAL') {
        errors.push('PARTIAL freshness requires partialData');
    }
    if (metadata.dataQuality.freshness === 'UNAVAILABLE' && metadata.publicationState === 'PUBLISHED') {
        errors.push('UNAVAILABLE data cannot be PUBLISHED');
    }
    return errors;
}
